"use strict";

var _webfontloader = _interopRequireDefault(require("webfontloader"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

_webfontloader["default"].load({
  google: {
    families: ['Nunito:200,300,400,400i', 'PT+Sans:400,400i,700']
  },
  custom: {
    families: ['Comicrazy']
  }
});